export default {
  props: {
    /**
     * @model
     */
    value: {
      type: [String, Number],
      default: null
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },
  computed: {
    inputValue: {
      get () {
        if (!this.value) {
          return this.localValue
        }
        return this.value
      },
      set (val) {
        /**
        * Used for v-model
        * @property {String}
        */
        this.$emit('input', val)
        this.localValue = val
        return val
      }
    }
  },
  watch: {
    value (val) {
      this.localValue = val
    }
  }
}
